import { render } from "./authorizeByUser.vue?vue&type=template&id=0da4c4c1&scoped=true"
import script from "./authorizeByUser.vue?vue&type=script&lang=js"
export * from "./authorizeByUser.vue?vue&type=script&lang=js"

import "./authorizeByUser.vue?vue&type=style&index=0&id=0da4c4c1&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da4c4c1"]])

export default __exports__